export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
export const kv = (key, value) => {
    const type = typeof value;
    switch (type) {
        case 'object':
            return `${key}="${JSON.stringify(value)}`;
        case 'undefined':
            return `${key}=undefined`;
        default:
            return `${key}="${value}"`;
    }
};
